import { AccountType } from '@rematter/frontend-lib-api-client/grpc/crm/v1/account_pb';

export const accountTypeLabels: Record<AccountType, string> = {
  [AccountType.UNSPECIFIED]: 'Unspecified',
  [AccountType.COMMERCIAL]: 'Commercial',
  [AccountType.INDIVIDUAL]: 'Individual',
};
